import React, { createContext, useState, useContext, ReactNode } from 'react';

// Importando as traduções (baseadas no arquivo JS original)
const translations = {
  pt: {
    nav_home: "Início",
    nav_about: "Sobre",
    nav_how_works: "Como Funciona",
    nav_cities: "Cidades",
    nav_map: "Mapa",
    nav_contact: "Contato",
    hero_title: "TURoad\nHistórias que ligam pessoas a lugares no Brasil",
    hero_subtitle: "Mobilidade e Turismo Inteligente em todas regiões do Brasil",
    cta_learn_more: "Saiba Mais",
    cta_explore: "Explorar Cidades",
    about_title: "Sobre o TURoad",
    about_p1: "O TURoad é uma plataforma digital integrada que conecta turistas, atrativos e pequenos empreendedores em rotas turísticas inteligentes pela Região Integrada de Desenvolvimento do Distrito Federal e Entorno (RIDE).",
    about_p2: "Funcionando como um hub de mobilidade e experiências, o TURoad tem foco em desenvolvimento regional e inclusão econômica, promovendo o turismo sustentável e a valorização da cultura local.",
    about_p3: "Nossa missão é transformar a experiência de visitantes e moradores, proporcionando conhecimento sobre a história, cultura e belezas naturais das 31 cidades satélites do Distrito Federal.",
    feature1_title: "Rotas Inteligentes",
    feature1_desc: "Descubra caminhos personalizados que conectam pontos turísticos, restaurantes locais e atrações culturais.",
    feature2_title: "Guia de Áudio",
    feature2_desc: "Ouça histórias fascinantes sobre cada cidade enquanto você se aproxima pelas rodovias de acesso ao DF.",
    
    // Seção Como Funciona
    how_works_title: "Como Funciona",
    step1_title: "Baixe o Aplicativo",
    step1_desc: "Disponível para Android e iOS, o aplicativo TURoad é gratuito e fácil de usar. Baixe-o antes de iniciar sua viagem pelo DF.",
    step2_title: "Viaje pelas Rodovias",
    step2_desc: "Ao se aproximar das rodovias de acesso ao DF, o TURoad será automaticamente ativado, identificando sua localização.",
    step3_title: "Ouça as Histórias",
    step3_desc: "O aplicativo começará a narrar a história da cidade que você está se aproximando, enriquecendo sua experiência de viagem.",
    step4_title: "Explore Atrações",
    step4_desc: "Descubra pontos turísticos, restaurantes, eventos culturais e muito mais em cada cidade que visitar.",
    step5_title: "Apoie o Comércio Local",
    step5_desc: "Conecte-se com pequenos empreendedores locais e contribua para o desenvolvimento econômico da região.",
    step6_title: "Compartilhe Experiências",
    step6_desc: "Registre suas visitas, avalie os locais e compartilhe suas experiências com outros viajantes.",
    audio_demo_title: "Demonstração de Áudio",
    audio_demo_desc: "Escute uma amostra de como o TURoad narra a história das cidades. Selecione o idioma da sua preferência:",
    audio_pt: "Português",
    audio_en: "Inglês",
    audio_es: "Espanhol",
    
    // Seção Cidades
    cities_title: "Cidades do Brasil",
    cities_subtitle: "Conheça as histórias e pontos turísticos das cidades brasileiras atendidas pelo TURoad",
    view_all_cities: "Ver Todas as Cidades",
    modal_history: "História",
    modal_culture: "Cultura",
    modal_attractions: "Atrações",
    modal_listen: "Ouça sobre esta cidade:",
    
    // Outras seções
    map_title: "Mapa Interativo",
    map_subtitle: "Explore as cidades e atrações turísticas em nosso mapa interativo",
    map_legend_audio: "Cidades com áudio-guias",
    map_legend_poi: "Pontos de interesse",
    
    data_title: "Dados e Estatísticas",
    data_subtitle: "Conheça os números e estatísticas sobre o turismo nas cidades brasileiras",
    chart1_title: "Visitas Mensais",
    chart2_title: "Impacto Econômico Local",
    chart_source: "Fonte: Ministério do Turismo do Brasil, 2024",
    
    sponsors_title: "Nossos Parceiros",
    sponsors_subtitle: "Empresas e instituições que acreditam e apoiam o projeto TURoad",
    sponsor1_title: "Sua empresa aqui",
    sponsor1_desc: "Apoie o turismo e destaque sua marca para visitantes de todo o Brasil",
    sponsor2_title: "Sua instituição aqui",
    sponsor2_desc: "Parcerias institucionais para promoção da cultura e turismo brasileiro",
    sponsor3_title: "Seu apoio aqui",
    sponsor3_desc: "Sua contribuição é importante para o desenvolvimento do turismo no Brasil",
    sponsor4_title: "Sua tecnologia aqui",
    sponsor4_desc: "Inovação tecnológica para transformar a experiência turística no Brasil",
    become_sponsor: "Torne-se um Parceiro",
    
    // Footer
    footer_links: "Links Rápidos",
    footer_contact: "Fale Conosco"
  },
  en: {
    nav_home: "Home",
    nav_about: "About",
    nav_how_works: "How It Works",
    nav_cities: "Cities",
    nav_map: "Map",
    nav_contact: "Contact",
    hero_title: "TURoad – Stories that connect people to places in Brazil",
    hero_subtitle: "Smart Mobility and Tourism across all regions of Brazil",
    cta_learn_more: "Learn More",
    cta_explore: "Explore Cities",
    about_title: "About TURoad",
    about_p1: "TURoad is an integrated digital platform that connects tourists, attractions, and small entrepreneurs on smart tourist routes across all regions of Brazil.",
    about_p2: "Working as a mobility and experiences hub, TURoad focuses on regional development and economic inclusion, promoting sustainable tourism and appreciation of local culture.",
    about_p3: "Our mission is to transform the experience of visitors and residents, providing knowledge about the history, culture, and natural beauty of Brazilian cities.",
    feature1_title: "Smart Routes",
    feature1_desc: "Discover personalized paths that connect tourist spots, local restaurants, and cultural attractions.",
    feature2_title: "Audio Guide",
    feature2_desc: "Listen to fascinating stories about each city as you approach via the highways.",
    
    // How It Works Section
    how_works_title: "How It Works",
    step1_title: "Download the App",
    step1_desc: "Available for Android and iOS, the TURoad app is free and easy to use. Download it before starting your journey.",
    step2_title: "Travel on the Highways",
    step2_desc: "As you approach the access highways, TURoad will automatically activate, identifying your location.",
    step3_title: "Listen to the Stories",
    step3_desc: "The app will start narrating the history of the city you're approaching, enriching your travel experience.",
    step4_title: "Explore Attractions",
    step4_desc: "Discover tourist spots, restaurants, cultural events, and much more in each city you visit.",
    step5_title: "Support Local Business",
    step5_desc: "Connect with small local entrepreneurs and contribute to the economic development of the region.",
    step6_title: "Share Experiences",
    step6_desc: "Record your visits, rate the places, and share your experiences with other travelers.",
    audio_demo_title: "Audio Demo",
    audio_demo_desc: "Listen to a sample of how TURoad narrates the history of cities. Select your preferred language:",
    audio_pt: "Portuguese",
    audio_en: "English",
    audio_es: "Spanish",
    
    // Cities Section
    cities_title: "Cities of Brazil",
    cities_subtitle: "Discover the stories and tourist attractions of Brazilian cities covered by TURoad",
    view_all_cities: "View All Cities",
    modal_history: "History",
    modal_culture: "Culture",
    modal_attractions: "Attractions",
    modal_listen: "Listen about this city:",
    
    // Other sections
    map_title: "Interactive Map",
    map_subtitle: "Explore cities and tourist attractions on our interactive map",
    map_legend_audio: "Cities with audio guides",
    map_legend_poi: "Points of interest",
    
    data_title: "Data and Statistics",
    data_subtitle: "Learn about the numbers and statistics on tourism in Brazilian cities",
    chart1_title: "Monthly Visits",
    chart2_title: "Local Economic Impact",
    chart_source: "Source: Brazilian Ministry of Tourism, 2024",
    
    sponsors_title: "Our Partners",
    sponsors_subtitle: "Companies and institutions that believe in and support the TURoad project",
    sponsor1_title: "Your company here",
    sponsor1_desc: "Support tourism and showcase your brand to visitors from all over Brazil",
    sponsor2_title: "Your institution here",
    sponsor2_desc: "Institutional partnerships for promoting Brazilian culture and tourism",
    sponsor3_title: "Your support here",
    sponsor3_desc: "Your contribution is important for the development of tourism in Brazil",
    sponsor4_title: "Your technology here",
    sponsor4_desc: "Technological innovation to transform the tourist experience in Brazil",
    become_sponsor: "Become a Partner",
    
    // Footer
    footer_links: "Quick Links",
    footer_contact: "Contact Us"
  },
  es: {
    nav_home: "Inicio",
    nav_about: "Sobre",
    nav_how_works: "Cómo Funciona",
    nav_cities: "Ciudades",
    nav_map: "Mapa",
    nav_contact: "Contacto",
    hero_title: "TURoad – Historias que conectan personas a lugares en Brasil",
    hero_subtitle: "Movilidad y Turismo Inteligente en todas las regiones de Brasil",
    cta_learn_more: "Saber Más",
    cta_explore: "Explorar Ciudades",
    about_title: "Sobre TURoad",
    about_p1: "TURoad es una plataforma digital integrada que conecta turistas, atracciones y pequeños emprendedores en rutas turísticas inteligentes en todas las regiones de Brasil.",
    about_p2: "Funcionando como un centro de movilidad y experiencias, TURoad se enfoca en el desarrollo regional y la inclusión económica, promoviendo el turismo sostenible y la valorización de la cultura local.",
    about_p3: "Nuestra misión es transformar la experiencia de visitantes y residentes, proporcionando conocimiento sobre la historia, cultura y bellezas naturales de las ciudades brasileñas.",
    feature1_title: "Rutas Inteligentes",
    feature1_desc: "Descubre caminos personalizados que conectan puntos turísticos, restaurantes locales y atracciones culturales.",
    feature2_title: "Guía de Audio",
    feature2_desc: "Escucha historias fascinantes sobre cada ciudad mientras te acercas por las carreteras.",
    
    // Sección Cómo Funciona
    how_works_title: "Cómo Funciona",
    step1_title: "Descarga la Aplicación",
    step1_desc: "Disponible para Android e iOS, la aplicación TURoad es gratuita y fácil de usar. Descárgala antes de iniciar tu viaje.",
    step2_title: "Viaja por las Carreteras",
    step2_desc: "Al acercarte a las carreteras de acceso, TURoad se activará automáticamente, identificando tu ubicación.",
    step3_title: "Escucha las Historias",
    step3_desc: "La aplicación comenzará a narrar la historia de la ciudad a la que te estás acercando, enriqueciendo tu experiencia de viaje.",
    step4_title: "Explora Atracciones",
    step4_desc: "Descubre puntos turísticos, restaurantes, eventos culturales y mucho más en cada ciudad que visites.",
    step5_title: "Apoya el Comercio Local",
    step5_desc: "Conéctate con pequeños emprendedores locales y contribuye al desarrollo económico de la región.",
    step6_title: "Comparte Experiencias",
    step6_desc: "Registra tus visitas, evalúa los lugares y comparte tus experiencias con otros viajeros.",
    audio_demo_title: "Demostración de Audio",
    audio_demo_desc: "Escucha una muestra de cómo TURoad narra la historia de las ciudades. Selecciona tu idioma preferido:",
    audio_pt: "Portugués",
    audio_en: "Inglés",
    audio_es: "Español",
    
    // Sección Ciudades
    cities_title: "Ciudades de Brasil",
    cities_subtitle: "Conoce las historias y puntos turísticos de las ciudades brasileñas atendidas por TURoad",
    view_all_cities: "Ver Todas las Ciudades",
    modal_history: "Historia",
    modal_culture: "Cultura",
    modal_attractions: "Atracciones",
    modal_listen: "Escucha sobre esta ciudad:",
    
    // Otras secciones
    map_title: "Mapa Interactivo",
    map_subtitle: "Explora las ciudades y atracciones turísticas en nuestro mapa interactivo",
    map_legend_audio: "Ciudades con audio-guías",
    map_legend_poi: "Puntos de interés",
    
    data_title: "Datos y Estadísticas",
    data_subtitle: "Conoce los números y estadísticas sobre el turismo en las ciudades brasileñas",
    chart1_title: "Visitas Mensuales",
    chart2_title: "Impacto Económico Local",
    chart_source: "Fuente: Ministerio de Turismo de Brasil, 2024",
    
    sponsors_title: "Nuestros Colaboradores",
    sponsors_subtitle: "Empresas e instituciones que creen y apoyan el proyecto TURoad",
    sponsor1_title: "Su empresa aquí",
    sponsor1_desc: "Apoye el turismo y destaque su marca para visitantes de todo Brasil",
    sponsor2_title: "Su institución aquí",
    sponsor2_desc: "Alianzas institucionales para promover la cultura y el turismo brasileño",
    sponsor3_title: "Su apoyo aquí",
    sponsor3_desc: "Su contribución es importante para el desarrollo del turismo en Brasil",
    sponsor4_title: "Su tecnología aquí",
    sponsor4_desc: "Innovación tecnológica para transformar la experiencia turística en Brasil",
    become_sponsor: "Conviértase en Colaborador",
    
    // Footer
    footer_links: "Enlaces Rápidos",
    footer_contact: "Contáctenos"
  },
};

type Language = 'pt' | 'en' | 'es';

interface I18nContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const I18nContext = createContext<I18nContextType | undefined>(undefined);

interface I18nProviderProps {
  children: ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('pt');

  const t = (key: string): string => {
    // @ts-ignore - As traduções podem não ter todas as chaves
    return translations[language][key] || key;
  };

  return (
    <I18nContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};
